"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDividerWidget = void 0;
var tslib_1 = require("tslib");
/* eslint-disable jsx-a11y/no-redundant-roles */
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../styles/TabStyles");
var Colors = TabStyles_1.TabStyles.Colors;
var DividerStyleName = TypeStyle.style({
    border: 'none',
    borderTop: "1px solid " + Colors.L3,
    margin: '8px 0',
});
var MenuDividerWidget = function () {
    return React.createElement("hr", { "aria-orientation": 'horizontal', className: DividerStyleName, role: 'separator' });
};
exports.MenuDividerWidget = MenuDividerWidget;
exports.MenuDividerWidget.displayName = 'MenuDividerWidget';
//# sourceMappingURL=MenuDividerWidget.js.map